import { render, staticRenderFns } from "./Contacto-add.vue?vue&type=template&id=42a12fd0"
import script from "./Contacto-add.vue?vue&type=script&lang=js"
export * from "./Contacto-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports